import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { getUser } = useAuthStore();

  if(getUser.role !== "PLAYER"){
    return navigateTo('/')
  }
});
